// src/polaris-components/DeleteAthleteModal.tsx
import React from "react";
import "../styles/delete-athlete-modal.css";

export type DeleteAthleteModalProps = {
    open: boolean;
    athleteName: string;
    onClose: () => void;
    onConfirm: () => void;
    loading?: boolean;
    error?: string;
};

/**
 * Reusable modal component for confirming athlete deletion
 * Used across the application wherever athletes need to be deleted
 */
export default function DeleteAthleteModal({
    open,
    athleteName,
    onClose,
    onConfirm,
    loading = false,
    error,
}: DeleteAthleteModalProps) {
    if (!open) return null;

    return (
        <div className="delete-athlete-modal-overlay" onClick={onClose}>
            <div className="delete-athlete-modal-content" onClick={(e) => e.stopPropagation()}>
                <h2 className="delete-athlete-modal-title">Delete Athlete</h2>
                <p className="delete-athlete-modal-message">
                    Are you sure you want to delete <strong>{athleteName}</strong>? This action cannot be undone.
                    Any parent/guardian account that is not linked to another athlete will also be removed.
                </p>
                {error ? (
                    <p className="delete-athlete-modal-error" role="alert">
                        {error}
                    </p>
                ) : null}
                <div className="delete-athlete-modal-actions">
                    <button
                        className="delete-athlete-modal-btn delete-athlete-modal-cancel"
                        onClick={onClose}
                        disabled={loading}
                    >
                        Cancel
                    </button>
                    <button
                        className="delete-athlete-modal-btn delete-athlete-modal-confirm"
                        onClick={onConfirm}
                        disabled={loading}
                    >
                        {loading ? 'Deleting...' : 'Delete'}
                    </button>
                </div>
            </div>
        </div>
    );
}

